import Image from "next/image";
import defaultRo from "@/assets/img/institution-avatar.png";
import defaultUs from "@/assets/img/institutions/default-us.png";
import { Icon } from "@iconify/react";
interface SidebarHeaderProps {
  institutionLogo?: string | null;
  title: string;
  description: string;
  locale?: string;
  population?: {
    year: number;
    population: number;
  };
}
export const InstitutionDetails: React.FC<SidebarHeaderProps> = ({
  institutionLogo,
  title,
  description,
  locale = "en-US",
  population
}) => {
  const defaultAvatar = locale === "ro" ? defaultRo : defaultUs;
  const formattedPopulation = population ? new Intl.NumberFormat(locale).format(population.population) : null;
  return <div className="mb-3 flex flex-col items-center gap-6 text-center mobile:gap-0 mobile:text-left" data-sentry-component="InstitutionDetails" data-sentry-source-file="InstitutionDetails.tsx">
      <div className="pointer-events-none relative h-40 w-40 overflow-hidden rounded-3xl border border-primary/20" style={{
      minWidth: "160px",
      minHeight: "160px",
      maxWidth: "160px",
      maxHeight: "160px"
    }}>
        <Image src={institutionLogo || defaultAvatar} alt="Institution Logo" objectFit="cover" width={160} height={160} data-sentry-element="Image" data-sentry-source-file="InstitutionDetails.tsx" />
      </div>
      <h2 className="text-lg font-semibold mobile:mt-4">{title}</h2>
      {population ? <div className="mt-1 flex items-center gap-2 text-sm text-blue-700">
          <Icon icon="ph:users-three-bold" className="h-5 w-5" />
          <span className="font-semibold">{formattedPopulation}</span>
        </div> : null}
      <p className="mt-1 hidden w-full text-sm mobile:block">{description}</p>
    </div>;
};